import React, { FC } from 'react';
import styled from 'styled-components';
import {
  variant,
  color,
  ColorProps,
  fontWeight,
  FontWeightProps,
  lineHeight,
  LineHeightProps,
  fontSize,
  FontSizeProps,
} from 'styled-system';

import { Box } from '~/components/Box';

const headingStyle = variant({
  key: 'headings',
});

export type HeadingProps = {
  variant: 'h1' | 'h2' | 'h3' | 'h4';
} & ColorProps &
  FontWeightProps &
  FontSizeProps &
  LineHeightProps;

const StyledHeading = styled(Box)<HeadingProps>`
  ${headingStyle};
  ${color};
  ${fontWeight};
  ${lineHeight};
  ${fontSize};
`;

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const HeadingDocz: FC<HeadingProps> = (props: any) => {
  return <Heading {...props} />;
};

export const Heading = Object.assign(StyledHeading, {
  defaultProps: {
    as: 'h2',
    variant: 'h3',
    lineHeight: 'normal',
    mt: 0,
    mb: 'm',
  },
});
try {
    // @ts-ignore
    HeadingDocz.displayName = "HeadingDocz";
    // @ts-ignore
    HeadingDocz.__docgenInfo = { "description": "", "displayName": "HeadingDocz", "props": { "variant": { "defaultValue": null, "description": "", "name": "variant", "required": true, "type": { "name": "\"h1\" | \"h2\" | \"h3\" | \"h4\"" } }, "color": { "defaultValue": null, "description": "The color utility parses a component's `color` and `bg` props and converts them into CSS declarations.\nBy default the raw value of the prop is returned.\n\nColor palettes can be configured with the ThemeProvider to use keys as prop values, with support for dot notation.\nArray values are converted into responsive values.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/color)", "name": "color", "required": false, "type": { "name": "ResponsiveValue<string>" } }, "bg": { "defaultValue": null, "description": "The color utility parses a component's `color` and `bg` props and converts them into CSS declarations.\nBy default the raw value of the prop is returned.\n\nColor palettes can be configured with the ThemeProvider to use keys as prop values, with support for dot notation.\nArray values are converted into responsive values.\n\n[MDN Reference](https://developer.mozilla.org/en-US/docs/Web/CSS/background-color)", "name": "bg", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } }, "fontWeight": { "defaultValue": null, "description": "The font-weight CSS property specifies the weight (or boldness) of the font.\n\nThe font weights available to you will depend on the font-family you are using. Some fonts are only available in normal and bold.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight)", "name": "fontWeight", "required": false, "type": { "name": "ResponsiveValue<FontWeightProperty>" } }, "fontSize": { "defaultValue": null, "description": "The fontSize utility parses a component's `fontSize` prop and converts it into a CSS font-size declaration.\n\n- Numbers from 0-8 (or `theme.fontSizes.length`) are converted to values on the [font size scale](#default-theme).\n- Numbers greater than `theme.fontSizes.length` are converted to raw pixel values.\n- String values are passed as raw CSS values.\n- And array values are converted into responsive values.", "name": "fontSize", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } }, "lineHeight": { "defaultValue": null, "description": "The line-height CSS property sets the amount of space used for lines, such as in text. On block-level elements,\nit specifies the minimum height of line boxes within the element.\n\nOn non-replaced inline elements, it specifies the height that is used to calculate line box height.\n\n[MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/line-height)", "name": "lineHeight", "required": false, "type": { "name": "ResponsiveValue<TLengthStyledSystem>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Heading/Heading.tsx#HeadingDocz"] = { docgenInfo: HeadingDocz.__docgenInfo, name: "HeadingDocz", path: "src/components/Heading/Heading.tsx#HeadingDocz" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    Heading.displayName = "Heading";
    // @ts-ignore
    Heading.__docgenInfo = { "description": "", "displayName": "Heading", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"h1\" | \"h2\" | \"h3\" | \"h4\" | \"small\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | ... 153 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Heading/Heading.tsx#Heading"] = { docgenInfo: Heading.__docgenInfo, name: "Heading", path: "src/components/Heading/Heading.tsx#Heading" };
}
catch (__react_docgen_typescript_loader_error) { }